<template>
  <div class="general-wrapper report-gap">
    <div class="left-part">
      <Header
        @toParent="$router.go(-1)"
        :parentText="$t('navigation.back')"
        :parent="null"
      >
        <template #supertitle>
          <div class="gap-column-1xs editor-supertitle">
            <div
              class="
                qrw-heading-sm
                bold
                qrw-text-content-base-primary
                editor-supertitle-value
              "
            >
              {{ form.title || $t("checklist_editor.new_ph") }}
            </div>
          </div>
        </template>
      </Header>

      <PageContainer style="position: relative" v-if="form._id">
        <div class="checklist-form-content">
          <ChecklistBlockBase buttonsPreset="none" :hoverable="false">
            <div class="gap-column-txs" v-if="form.tags.length">
              <BaseTag withIcon size="md" v-for="tag in form.tags" :key="tag">
                {{ tag }}
              </BaseTag>
            </div>
          </ChecklistBlockBase>

          <ChecklistBlockBase buttonsPreset="none" :hoverable="false">
            <div class="qrw-heading-lg bold qrw-text-content-base-primary">
              {{ form.title }}
            </div>
            <BaseDivider color="border-secondary" />
            <div class="qrw-paragraph-lg qrw-text-content-base-secondary">
              {{ form.description }}
            </div>
          </ChecklistBlockBase>

          <template v-for="block in visibleBlocks">
            <ChecklistBlock
              :form="form"
              :block="block"
              :metadata="{}"
              :key="block._id"
              v-if="block.type === 'CHECKLIST'"
            />
            <NumberBlock
              :form="form"
              :block="block"
              :metadata="{}"
              :key="block._id"
              v-else-if="block.type === 'NUMBER'"
            />
            <OptionsBlock
              :form="form"
              :block="block"
              :metadata="{}"
              :key="block._id"
              v-else-if="block.type === 'OPTIONS'"
            />
            <TextInputBlock
              :form="form"
              :block="block"
              :metadata="{}"
              :key="block._id"
              v-else-if="block.type === 'TEXT_INPUT'"
            />
            <FileUploadBlock
              :form="form"
              :block="block"
              :metadata="{}"
              :key="block._id"
              v-else-if="block.type === 'FILE_UPLOAD'"
            />
          </template>
        </div>

        <portal-target name="white-modal-portal"> </portal-target>
      </PageContainer>
    </div>
    <div class="report-sidebar">
      <div class="sidebar-block">
        <div class="qrw-label-sm qrw-text-content-base-secondary">
          Test Department
        </div>
        <div class="qrw-label-lg qrw-text-content-base-primary bold">
          {{ formWaiter.name }}
        </div>
      </div>
      <BaseDivider color="border-base-tertiary" />
      <div class="sidebar-block gap-row-1xs" v-if="scheduleState">
        <div class="qrw-text-content-base-secondary qrw-label-sm">
          {{ scheduleState.timeslot }} | {{ scheduleState.date }}
        </div>
        <BaseBadge
          variant="primary"
          color="content-error-primary"
          v-if="scheduleState.expired"
        >
          <div class="qrw-text-content-base-inverse-primary">
            {{ $t("checklist_reports.expired") }}
          </div>
        </BaseBadge>
        <BaseBadge variant="secondary" color="background-base-secondary" v-else>
          <div class="qrw-text-content-base-secondary">
            {{ $t("checklist_reports.scheduled") }}
          </div>
        </BaseBadge>
      </div>
      <BaseDivider color="border-base-tertiary" />
      <div class="sidebar-block gap-row-2xs">
        <div class="qrw-text-content-base-secondary qrw-label-sm">
          {{ $t("checklist_reports.report_time") }}
        </div>
        <div class="qrw-text-content-base-primary qrw-label-lg bold">
          {{ formattedFormTime }}
        </div>
      </div>
      <BaseDivider color="border-base-tertiary" />
      <div class="sidebar-block gap-row-2xs">
        <div class="qrw-text-content-base-secondary qrw-label-sm">
          {{ $t("checklist_reports.completeness") }}
        </div>
        <div
          class="bold qrw-label-lg"
          :class="{
            [`${completenessColor}-color`]: true,
          }"
        >
          {{ form.complete_percent }}%
        </div>
      </div>
      <BaseDivider color="border-base-tertiary" />
       <div class="sidebar-block gap-row-1xs">
        <div class="qrw-text-content-base-secondary qrw-label-sm">
          {{ $t("checklist_reports.checklist_stats") }}
        </div>
        <div class="qrw-label-lg gap-column-2xs" v-for="(count,type) in checklistStats" :key="type" :class="{
          [`qrw-text-${checklistStatsUiOptions[type][1]}`]: true
        }">
          <BaseIcon size="sm2" :icon="checklistStatsUiOptions[type][0]"/>
          <div class="bold">{{ count }}</div>
        </div>
      </div>
      <BaseDivider color="border-base-tertiary" />
      <div class="sidebar-block gap-row-2xs">
        <div class="qrw-text-content-base-secondary qrw-label-sm">
          {{ $t("checklist_reports.total_score") }}
        </div>
        <div class="qrw-text-content-base-primary bold qrw-label-lg">
          {{ form.total_score || $t("checklist_reports.none_score") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChecklistBlockBase from "@/components/checklists/blocks/ChecklistBlockBase.vue";
import ChecklistBlock from "@/components/checklists/reports/ChecklistBlock.vue";
import NumberBlock from "@/components/checklists/reports/NumberBlock.vue";
import OptionsBlock from "@/components/checklists/reports/OptionsBlock.vue";
import TextInputBlock from "@/components/checklists/reports/TextInputBlock.vue";
import FileUploadBlock from "@/components/checklists/reports/FileUploadBlock.vue";

import moment from "moment";

import ChecklistsAPI from "@/api/checklists";

export default {
  data() {
    return {
      form: {
        title: "test",
        blocks: [],
      },
    };
  },
  components: {
    ChecklistBlockBase,

    ChecklistBlock,
    NumberBlock,
    OptionsBlock,
    TextInputBlock,
    FileUploadBlock,
  },
  methods: {},
  computed: {
    nonStaticBlocks() {
      return this.form.blocks.filter(
        (b) =>
          !["STATIC_TEXT", "DIVIDER", "MEDIA_FILE", "DOCUMENT_FILE"].includes(
            b.type
          )
      );
    },
    completenessColor() {
      if (this.form.complete_percent === 100) return "green-6";
      if (this.form.complete_percent <= 25) return "red-5";

      return `orange-5`;
    },
    formWaiter() {
      return this.$store.state.waiters.find(
        (w) => w._id === this.form.waiter_id
      );
    },
    formattedFormTime() {
      return moment(this.form.completed_at).format("HH:mm");
    },
    scheduleState() {
      if (!this.form.scheduled_at) return null;

      return {
        expired: this.form.is_expired,
        timeslot:
          moment(this.form.scheduled_at).format("HH:mm") +
          " - " +
          moment(this.form.ends_at).format("HH:mm"),
        date: moment(this.form.scheduled_at).format("DD.MM.YYYY"),
      };
    },
    allOptionsIds() {
      return this.nonStaticBlocks
        .filter((b) => b.type === "OPTIONS")
        .map((b) => b.options.selected_option_id);
    },
    visibleBlocks() {
      return this.nonStaticBlocks.filter((b) => {
        if (b.dependency_option_id) {
          return this.allOptionsIds.includes(b.dependency_option_id);
        } else {
          return true;
        }
      });
    },
    checklistStats() {
      return this.visibleBlocks.filter(b => b.type === 'CHECKLIST').map(b => b.checklist.rows).flat().reduce((acc, it) => {
        return {
          ...acc,
          [it.status]: (acc[it.status] || 0) + 1
        }
      }, {});
    },
    checklistStatsUiOptions() {
      return {
        'none': ['square', 'content-base-tertiary'],
        'completed': ['check-square', 'content-success-primary'],
        'uncompleted': ['cross', 'content-error-primary'],
        'not_applicable': ['slash', 'content-base-secondary']
      }
    }
  },
  mounted() {
    ChecklistsAPI.getArchiveForm(this.$route.params.id)
      .then((data) => {
        if (!data.form) return this.$router.push("/checklists");

        this.form = data.form;

        this.$store.commit("checklists/setForm", this.form);
      })
      .catch((err) => {
        this.$router.push("/checklists");
      });
  },
};
</script>

<style scoped>
.checklist-form-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-top: 20px;
  padding-bottom: 40px;
  width: 100%;
}

.header-buttons {
  display: flex;
  flex-direction: row;
  column-gap: 12px;
}

.editor-supertitle {
  align-items: center;
}

.editor-supertitle-value {
  overflow: hidden;
  text-overflow: ellipsis;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  white-space: nowrap;
  max-width: 730px;
}

.report-header-item {
  width: fit-content;
  white-space: nowrap;
}

.report-header-score,
.report-header-percent,
.report-header-time {
  width: 100px;
  max-width: 100px;
  min-width: 100px;
}

.report-gap {
  display: flex;
  flex-direction: row;
}

.report-sidebar {
  width: 256px;
  display: flex;
  max-width: 256px;
  background: var(--qrw-background-base-secondary);
  flex-direction: column;
}

.sidebar-block {
  display: flex;
  flex-direction: column;
  padding: 16px 16px 12px;
}

.left-part {
  width: 100%;
}
</style>
